import React from "react";
import Content from "./Content";

export default function Screen(props) {
    return <div className={`Screen ${props?.hasOwnProperty('className') ? props.className : ''}`} style={{overflowY: 'auto'}}>
            <Content>
                {props.children}
            </Content>
           </div>
}